
import dayjs from 'dayjs'
import { defineComponent, PropType } from 'vue'

import { formatDate } from '@/utils/date'
import { IssueSeverity } from '~/types/types'
import { safeRenderBackticks } from '~/utils/string'
import { deslugifyTag, generateColorFromTag } from '~/utils/ui'

export default defineComponent({
  name: 'IssueDetailsHeader',
  props: {
    firstSeen: {
      type: String
    },
    issueType: {
      type: String
    },
    lastSeen: {
      type: String
    },
    shortcode: {
      type: String
    },
    title: {
      type: String
    },
    tags: {
      type: Array as PropType<Array<string>>,
      default: () => []
    },
    severity: {
      type: String as PropType<IssueSeverity>
    },
    count: {
      type: Number,
      default: 0
    }
  },
  computed: {
    lastSeenDisplay(): string {
      return dayjs(this.lastSeen).fromNow()
    },
    firstSeenDisplay(): string {
      return `${dayjs(this.firstSeen).fromNow(true)} old`
    }
  },
  methods: {
    deslugifyTag,
    safeRenderBackticks,
    formatDate,
    generateColorFromTag
  }
})
